// React imports.
import React from "react";


// App imports.
import Assessment5AssistedHouseholdsTableRow from "./Assessment5AssistedHouseholdsTableRow";

const Assessment5AssistedHouseholdsTable = ({ state }) => (
    <div>
        
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel	</div>
		
            {state.Assessment5Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&		
            <div className="header">Total # of Assisted Households	</div>
            }		
            {state.Assessment5Steps[state.CurrentAssessementStepIndex].showNumHouseholdsDataReceived === true &&		
            <div className="header"># of Households for Whom Main Heating Data was Received	</div>
            }		
            {state.Assessment5Steps[state.CurrentAssessementStepIndex].showpercentHouseholdsDataReceived === true &&		
            <div className="header">% of Households for Whom Main Heating Data was Received	</div>
            }		
            {state.Assessment5Steps[state.CurrentAssessementStepIndex].showDataReceivedStatus === true &&		
            <div className="header">Status	</div>
            }
            <Assessment5AssistedHouseholdsTableRow rowClass={state.getGridRowClass(state.Assessment5FuelTypesStatus.Electric.showAllFuels, state.Assessment5FuelTypesStatus.Electric.name )} state={state} fuel={state.Assessment5FuelTypesStatus.Electric} />
            <Assessment5AssistedHouseholdsTableRow rowClass={state.getGridRowClass(state.Assessment5FuelTypesStatus.NaturalGas.showAllFuels, state.Assessment5FuelTypesStatus.NaturalGas.name )} state={state} fuel={state.Assessment5FuelTypesStatus.NaturalGas} />
            <Assessment5AssistedHouseholdsTableRow rowClass={state.getGridRowClass(state.Assessment5FuelTypesStatus.FuelOil.showAllFuels, state.Assessment5FuelTypesStatus.FuelOil.name )} state={state} fuel={state.Assessment5FuelTypesStatus.FuelOil} />
            <Assessment5AssistedHouseholdsTableRow rowClass={state.getGridRowClass(state.Assessment5FuelTypesStatus.Propane.showAllFuels, state.Assessment5FuelTypesStatus.Propane.name )} state={state} fuel={state.Assessment5FuelTypesStatus.Propane} />

        </div>
    </div>
);

export default Assessment5AssistedHouseholdsTable;
